// extracted by mini-css-extract-plugin
module.exports = {"ToTopArrow":"ToTopArrow_ToTopArrow__EwRH2","ToTopArrowActive":"ToTopArrow_ToTopArrowActive__2aprC"};